import { useState } from 'react';
import { Button } from './Button.js';

/**
 * Copy a one-time secret. Minted tokens and invite links are shown once and
 * never again; `.token-once` set user-select:all so you could at least
 * triple-click, but there was no copy button and no confirmation that anything
 * had been copied.
 */
export function CopyButton({
  value,
  label = 'Copy',
}: {
  value: string;
  label?: string | undefined;
}) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => {
        navigator.clipboard
          .writeText(value)
          .then(() => setState('copied'))
          .catch(() => setState('failed'));
        setTimeout(() => setState('idle'), 2000);
      }}
    >
      {state === 'copied' ? 'Copied' : state === 'failed' ? 'Press ⌘C' : label}
    </Button>
  );
}
